"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChildNode = void 0;
function isChildNode(node) {
    return !!(node &&
        (node.type === 'atrule' ||
            node.type === 'rule' ||
            node.type === 'decl' ||
            node.type === 'comment'));
}
exports.isChildNode = isChildNode;
